import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Options } from 'focus-trap';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx/state';
import { CurrentUserAndPermissions } from '®shared/current-user/current-user-and-permissions';
import { UserRecord } from '®shared/user';

import {
  ListOwnersEditorHideModalAction,
  ListOwnersEditorSaveAction,
} from './list-owners-editor.actions';
import {
  ListOwnersEditorState,
  selectListOwnersEditorState,
} from './list-owners.state';

@Component({
  selector: 'rl-list-owners-editor-modal',
  templateUrl: './list-owners-editor-modal.component.html',
})
export class ListOwnersEditorModalComponent implements OnDestroy, OnInit {
  @Input() currentUser: CurrentUserAndPermissions;
  @Input() listOwners: UserRecord[];

  @ViewChild('listOwnersEditorModal', { static: true })
  public listOwnersEditorModal: ModalDirective;

  listOwnersEditorState: ListOwnersEditorState | null;

  focusTrapConfig: Options = {
    setReturnFocus: '#edit-list-btn',
    allowOutsideClick: true, // Ensure material autocomplete can be clicked on
  };

  private stateSubscription: Subscription;

  constructor(private cd: ChangeDetectorRef, private store: Store<State>) {}

  ngOnInit() {
    this.stateSubscription = this.store
      .select(selectListOwnersEditorState)
      .subscribe(state => {
        this.listOwnersEditorState = state;

        if (state.isModalShown && !this.listOwnersEditorModal.isShown) {
          this.listOwnersEditorModal.show();
        } else if (!state.isModalShown && this.listOwnersEditorModal.isShown) {
          this.listOwnersEditorModal.hide();
        }

        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  onSave(action: ListOwnersEditorSaveAction) {
    this.store.dispatch(action);
  }

  onHide() {
    this.store.dispatch(new ListOwnersEditorHideModalAction());
  }
}
